import { useApiQuery } from 'hooks/useApiQuery'
import { type RewardsRedemption } from 'types/api'
import { formatDateTime, removeUndefined } from 'utils/util'

export const useGetRewardsRedemptionsByRewardsProgramIdAndTransactionDate = ({
  rewardsProgramId,
  startDate,
  endDate,
}: {
  rewardsProgramId: number
  startDate?: string
  endDate?: string
  onSuccess?: (response: RewardsRedemption[]) => void
}) => {
  const queryArgs = removeUndefined({
    rewardsProgramId,
    startTransactionDate: formatDateTime(startDate, 'MM-dd-yyyy'),
    endTransactionDate: formatDateTime(endDate, 'MM-dd-yyyy'),
  })

  return useApiQuery({
    path: '/admin/rewards/redemptions/rewards-programs/{rewardsProgramId}',
    method: 'get',
    queryKey: [
      '/admin/redemptions/rewards/rewards-programs/rewardsProgramId/redemptions',
      rewardsProgramId,
      formatDateTime(startDate, 'MM-dd-yyyy'),
      formatDateTime(endDate, 'MM-dd-yyyy'),
    ],
    queryArgs,
    enabled: !!startDate && !!endDate,
  })
}
